import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { INatureOperation } from '@core-lib/models';
import { environment } from '@environments/environment';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { CarpaService } from './carpa.service';

@Injectable({
	providedIn: 'root'
})
export class NatureOperationService {
	get tenantKey(): string {
		return this.carpaService.currentCarpa.tenantKey;
	}

	constructor(private http: HttpClient, private carpaService: CarpaService) {}

	load(): Observable<INatureOperation[]> {
		return this.http.get(`${environment.apiUrl}/t/${this.tenantKey}/natureoperation`).pipe(map((i: any) => i?.items));
	}
}
